import JSONModel from "sap/ui/model/json/JSONModel";
import { Routes } from "akademika/akamont/constants/Routes";
import BaseController from "../sharedControllers/BaseController";

/**
 * @namespace akademika.akamont.pages.measurementUnitAdd
 */
export default class MeasurementUnitAdd extends BaseController {
  route = Routes.MEASUREMENT_UNIT_ADD;
  parentRoute = Routes.MEASUREMENT_UNIT_LIST;

  public onInit(): void {
    this.getView()?.setModel(new JSONModel(), "addForm");
  }

  public async onAdd() {
    const oAddModel = this.getView()?.getModel("addForm") as JSONModel;
    await this.saveDataAndShowMessage("api/MeasurementUnit/SaveNew", {
      body: oAddModel.getData(),
    });
    this.onNavBack();
  }
}
